import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "download-button" }
const _hoisted_2 = { class: "column-buttons" }
const _hoisted_3 = { class: "column-buttons" }
const _hoisted_4 = { class: "playlist-header-info" }
const _hoisted_5 = { class: "program-img-wrapper" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "playlist-duration-badge" }
const _hoisted_8 = { class: "track-number" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "track-info" }
const _hoisted_11 = { class: "track-name" }
const _hoisted_12 = { class: "track-duration" }
const _hoisted_13 = { class: "track-actions" }
const _hoisted_14 = { class: "play-button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: "main-background",
        fullscreen: true,
        slot: "fixed",
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, {
            class: "playlist-container bg-transparent",
            "scroll-y": false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, { mode: "md" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, { class: "playlist-name" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.selectedPlaylist.name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_buttons, { slot: "primary" }, {
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_ion_button, {
                            class: "playlist-header-button",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closePlaylist()))
                          }, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                              _createTextVNode("Закрыть", -1)
                            ]))]),
                            _: 1
                          }, 512), [
                            [_vShow, !_ctx.downloadProgressBar.downloading]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_list, {
                class: "playlist-content",
                lines: "none"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _withDirectives(_createVNode(_component_ion_button, {
                      fill: "outline",
                      class: "playlist-header-button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadPlaylist(_ctx.selectedPlaylist)))
                    }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("Загрузить оффлайн", -1)
                      ]))]),
                      _: 1
                    }, 512), [
                      [_vShow, 
                        !_ctx.selectedPlaylist.offline &&
                        !_ctx.downloadProgressBar.downloading &&
                        _ctx.globalContext.isMobile
                    ]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_ion_button, {
                        fill: "outline",
                        class: "playlist-header-button",
                        disabled: true
                      }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode("Доступно оффлайн", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        fill: "outline",
                        class: "playlist-header-button remove-download-button",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeDownloadedPlaylist(_ctx.selectedPlaylist)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: _ctx.trashOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ], 512), [
                      [_vShow, 
                        _ctx.selectedPlaylist.offline && !_ctx.downloadProgressBar.downloading
                    ]
                    ])
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_ion_button, {
                      fill: "outline",
                      class: "playlist-header-button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.stopDownload()))
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("Отмена", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_ion_text, { class: "playlist-header-button ion-text-center" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.downloadProgressBar.downloaded) + " Mb", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_text, { class: "playlist-header-button ion-text-center" }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode("Не закрывайте окно до завершения загрузки", -1)
                      ]))]),
                      _: 1
                    })
                  ], 512), [
                    [_vShow, _ctx.downloadProgressBar.downloading]
                  ]),
                  _withDirectives(_createVNode(_component_ion_progress_bar, {
                    value: 
                    _ctx.downloadProgressBar.currentValue /
                    _ctx.downloadProgressBar.maxValue
                    ,
                    class: "download-progress-bar"
                  }, null, 8, ["value"]), [
                    [_vShow, _ctx.downloadProgressBar.downloading]
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("img", {
                        src: _ctx.programLogo || _ctx.getProgramImage(_ctx.selectedPlaylist.programShortName),
                        alt: "program logo"
                      }, null, 8, _hoisted_6)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_ion_icon, { icon: _ctx.timeOutline }, null, 8, ["icon"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.mediaUtils.formatTime(
                            _ctx.mediaUtils.getTotalPlaylistDuration(_ctx.selectedPlaylist.tracks)
                        )), 1)
                    ])
                  ]),
                  _createVNode(_component_ion_content, { forceOverscroll: true }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPlaylist.tracks, (track, idx) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: idx,
                          onClick: ($event: any) => (_ctx.selectTrack(idx)),
                          class: _normalizeClass(["track-item", { 'playing': !_ctx.isFirstSelect && _ctx.playerBar.currentTrackIdx === idx }])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              (!(_ctx.playerBar.currentTrackIdx === idx && !_ctx.isFirstSelect))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(idx + 1), 1))
                                : (_openBlock(), _createBlock(_component_ion_icon, {
                                    key: 1,
                                    icon: _ctx.play,
                                    class: "playing-icon"
                                  }, null, 8, ["icon"]))
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.mediaUtils.getTrackName(track)), 1),
                              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.mediaUtils.formatTime(track.duration)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                _createVNode(_component_ion_icon, {
                                  icon: !_ctx.isFirstSelect && _ctx.playerBar.currentTrackIdx === idx ? _ctx.pause : _ctx.play,
                                  class: "play-icon"
                                }, null, 8, ["icon"])
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["onClick", "class"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}